import { render, staticRenderFns } from "./Additional.vue?vue&type=template&id=4df0999f"
import script from "./Additional.vue?vue&type=script&lang=js"
export * from "./Additional.vue?vue&type=script&lang=js"
import style0 from "../../../styles/autocomplete.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Additional.vue?vue&type=style&index=1&id=4df0999f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports